import type { ActivityModule } from '../../core/activity';
import { runLearnArithmeticActivity, type LearnArithmeticLevelsFile } from '../../shared/learn-arithmetic-runner';
import levelsData from './levels.json';

const LEVELS = (levelsData as LearnArithmeticLevelsFile).levels;

export const learnAdditions: ActivityModule = {
  id: 'learn_additions',
  title: 'Aprender adição',
  description: 'Veja a operação, preencha círculos com a quantidade certa para representar o resultado.',
  ageMin: 5,
  ageMax: 8,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/learn_additions/icon.svg',
  category: 'aritmetica',
  totalLevels: LEVELS.length,
  mount: (ctx) =>
    runLearnArithmeticActivity(ctx, {
      activityId: 'learn_additions',
      title: 'Aprender adição',
      levels: LEVELS,
    }),
};
